module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }